var _g, _g2, _g3, _circle, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 750,
    viewBox: "0 0 677 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_867_405)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.398,
    cy: 338.635,
    r: 203.239,
    transform: "rotate(-11.0425 338.398 338.635)",
    fill: "url(#paint0_linear_867_405)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_867_405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.608,
    y: 342.257,
    width: 195.308,
    height: 277.1,
    transform: "rotate(-11.0425 239.608 342.257)",
    fill: "url(#paint1_linear_867_405)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_867_405)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360.754,
    cy: 366.343,
    r: 156.44,
    transform: "rotate(23.7155 360.754 366.343)",
    fill: "url(#paint2_linear_867_405)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360.754,
    cy: 366.343,
    r: 156.137,
    transform: "rotate(23.7155 360.754 366.343)",
    stroke: "url(#paint3_linear_867_405)",
    strokeWidth: 0.604632,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.917 362.721C432.84 376.177 429.752 389.606 423.042 401.307C416.333 413.009 406.305 422.458 394.225 428.46C382.146 434.461 368.558 436.746 355.179 435.025C341.801 433.304 329.234 427.655 319.066 418.791C308.899 409.928 301.589 398.248 298.059 385.23C294.53 372.211 294.941 358.438 299.239 345.653C303.538 332.868 311.531 321.645 322.208 313.403C332.886 305.16 345.767 300.27 359.224 299.349C377.267 298.114 395.062 304.097 408.694 315.981C422.326 327.865 430.68 344.678 431.917 362.721ZM346.474 395.732L333.257 396.633C331.598 396.966 329.885 396.902 328.256 396.448C327.772 396.181 327.362 395.799 327.063 395.335C326.764 394.87 326.585 394.339 326.543 393.788C326.478 392.835 327.033 391.562 328.221 389.05L356.924 329.518C358.141 327.004 358.752 325.708 359.672 325.167C360.123 324.891 360.635 324.728 361.162 324.692C361.69 324.656 362.218 324.748 362.703 324.96C363.619 325.338 364.39 326.54 365.965 328.864L373.433 340.111C374.647 341.706 375.634 343.463 376.364 345.33C376.83 346.828 376.938 348.414 376.68 349.961C376.199 351.955 375.444 353.872 374.435 355.657L359.351 387.177C358.624 389.049 357.635 390.809 356.414 392.403C355.344 393.58 354.012 394.487 352.526 395.052C350.543 395.52 348.511 395.748 346.474 395.732ZM379.826 393.459L398.703 392.173C400.41 392.266 402.115 391.97 403.69 391.307C404.128 390.973 404.477 390.537 404.708 390.038C404.94 389.538 405.045 388.99 405.017 388.44C404.952 387.487 404.262 386.356 402.812 384.186L402.797 383.967L392.221 368.413L392.21 368.251C390.741 366.082 389.968 364.995 389.196 364.627C388.712 364.415 388.183 364.323 387.656 364.359C387.128 364.395 386.617 364.558 386.166 364.833C385.338 365.33 384.694 366.561 383.486 369.056L374.908 385.916C373.69 388.411 373.075 389.64 373.169 390.601C373.223 391.15 373.409 391.679 373.71 392.142C374.012 392.604 374.42 392.988 374.901 393.259C376.496 393.699 378.171 393.768 379.797 393.461L379.826 393.459Z",
    fill: "#FFDFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_867_405",
    x: 0.301422,
    y: 0.538483,
    width: 676.193,
    height: 676.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.4095,
    result: "effect1_foregroundBlur_867_405"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_867_405",
    x: 104.789,
    y: 170.029,
    width: 514.405,
    height: 579.016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.4095,
    result: "effect1_foregroundBlur_867_405"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_867_405",
    x: 161.951,
    y: 149.4,
    width: 355.282,
    height: 397.607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -42.3242,
    dy: -60.4632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48.3815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.645833 0 0 0 0 0.0592014 0 0 0 0 0.0592014 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_867_405"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24.1853
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.1606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_867_405",
    result: "effect2_innerShadow_867_405"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.4963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.916667 0 0 0 0 0.259722 0 0 0 0 0.259722 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_867_405",
    result: "effect3_innerShadow_867_405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_405",
    x1: 338.398,
    y1: 135.395,
    x2: 338.398,
    y2: 541.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0909",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_867_405",
    x1: 337.262,
    y1: 342.257,
    x2: 337.262,
    y2: 619.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1414",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1010",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_867_405",
    x1: 214.965,
    y1: 305.764,
    x2: 399.365,
    y2: 382.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_867_405",
    x1: 360.754,
    y1: 209.903,
    x2: 360.754,
    y2: 522.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41418"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.c0fb7bf46063227ab05c60fda690cfd7.svg";
export { ForwardRef as ReactComponent };